<h3 *ngIf="heading" [innerText]="heading"></h3>

<div class="header-text-bottom">
  <h1 class="d-inline cursive" [innerText]="title"></h1>
  <h3 class="d-inline" [innerText]="subtitle"></h3>
</div>
